







import Vue from 'vue'
import borderButton from '@/components/border-button.vue'
export default Vue.extend({
  components: { 'border-button': borderButton }
})
